import { cnpjValidator } from "./cnpjValidator";
import { cpfValidator } from "./cpfValidator";

export function GetPersonType(document: string): PersonTypeEnum {
  const personType = cpfValidator(document) ? PersonTypeEnum.PF : cnpjValidator(document) ? PersonTypeEnum.PJ : PersonTypeEnum.PF;
  return personType;
}

export enum PersonTypeEnum {
  PJ,
  PF
}



// WEBPACK FOOTER //
// ./src/util/GetPersonType.ts